export default __webpack_public_path__ + "locales/si/Article.json?hash=289ad5bd30597f8716f30e756cffd2fb";